/**
 * Upgrade undersized Shopify CDN images in blog/article rich content ONLY.
 * Never touch product grids — rewriting srcset widths breaks responsive loading.
 */
(function () {
  var TARGET = 1200;
  var MIN_KEEP = 600;
  var SCOPE =
    '.wmn-article-body, .wmn-guide-article, .article_content, .news-blurb, .blog-shop-cta, .playlist-sidebar, #shopify-section-article-template .rte';

  function upgradeUrl(url) {
    if (!url || typeof url !== 'string') return url;
    if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) {
      return url;
    }
    var next = url;
    next = next.replace(
      /_(pico|icon|thumb|small|compact|medium|large|grande)(?=\.|_)/gi,
      '_' + TARGET + 'x'
    );
    next = next.replace(/_(\d+)x(\d*)(?=\.|_|\?|$)/g, function (m, w) {
      var n = parseInt(w, 10);
      if (!n || n >= MIN_KEEP) return m;
      return '_' + TARGET + 'x';
    });
    return next;
  }

  function upgradeSrcset(value) {
    if (!value) return value;
    return value
      .split(',')
      .map(function (part) {
        var bits = part.trim().split(/\s+/);
        if (!bits[0]) return part;
        // Keep descriptor in sync with the actual file width we request.
        var desc = bits[1] || '';
        var m = desc.match(/^(\d+)w$/);
        if (m) {
          var want = parseInt(m[1], 10);
          if (want > 0 && want < MIN_KEEP) {
            bits[0] = bits[0].replace(
              /_(\d+)x(\d*)(?=\.|_|\?|$)/,
              '_' + Math.min(TARGET, Math.max(want, MIN_KEEP)) + 'x'
            );
            return bits.join(' ');
          }
        }
        bits[0] = upgradeUrl(bits[0]);
        return bits.join(' ');
      })
      .join(', ');
  }

  function upgradeImg(img) {
    if (!img || img.getAttribute('data-wmn-img-upgraded') === '1') return;
    // Never rewrite product-card / collection grid images.
    if (
      img.closest &&
      img.closest(
        '.thumbnail, .product-wrap, .product_image, .products-slider, .product-list, .wmn-search-discover, .cart_image'
      )
    ) {
      return;
    }
    ['src', 'data-src', 'data-original'].forEach(function (attr) {
      var v = img.getAttribute(attr);
      if (!v) return;
      var u = upgradeUrl(v);
      if (u !== v) img.setAttribute(attr, u);
    });
    ['srcset', 'data-srcset'].forEach(function (attr) {
      var v = img.getAttribute(attr);
      if (!v) return;
      var u = upgradeSrcset(v);
      if (u !== v) img.setAttribute(attr, u);
    });
    img.setAttribute('data-wmn-img-upgraded', '1');
  }

  function run(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) upgradeImg(imgs[i]);
  }

  function boot() {
    var scopes = document.querySelectorAll(SCOPE);
    if (!scopes.length) return;
    for (var s = 0; s < scopes.length; s++) run(scopes[s]);

    if (window.MutationObserver) {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (n.tagName === 'IMG') upgradeImg(n);
            else run(n);
          }
        }
      });
      for (var t = 0; t < scopes.length; t++) {
        obs.observe(scopes[t], { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  if (window.InstantClick) {
    try {
      InstantClick.on('change', function () {
        setTimeout(boot, 0);
      });
    } catch (e) {}
  }
})();
